// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ChatFillIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={22} viewBox="0 0 20 22" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="chat-fill" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Shape" fill="currentColor" fillRule="nonzero" d="M18 2q.824 0 1.413.587Q20 3.176 20 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 18H4l-4 4V4q0-.824.588-1.412A1.93 1.93 0 0 1 2 2zm-6 9H4v2h8zm4-4H4v2h12z" /></g></svg>
))
